import * as React from "react";

const Cart: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="-1 -1 28 28"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M9.502 19.852a3.074 3.074 0 100 6.148 3.074 3.074 0 000-6.148m0 1.17c1.05 0 1.903.854 1.903 1.904 0 1.05-.854 1.904-1.903 1.904a1.906 1.906 0 01-1.904-1.904c0-1.05.854-1.903 1.904-1.903m10.122-1.17a3.074 3.074 0 100 6.147 3.074 3.074 0 000-6.148m0 1.17c1.05 0 1.903.854 1.903 1.904 0 1.05-.853 1.904-1.903 1.904a1.906 1.906 0 01-1.904-1.904c0-1.05.854-1.903 1.904-1.903m-13.111-3.38h19.162c.18 0 .325.145.325.324v.52c0 .18-.146.325-.325.325H5.495c-.161 0-.299-.119-.321-.28L2.782 1.45a.325.325 0 00-.322-.28H.325A.325.325 0 010 .845v-.52C0 .145.146 0 .325 0h3.152c.163 0 .3.12.322.28l1.853 13.235H20.61c.126 0 .24-.073.294-.187l3.898-8.282a.325.325 0 01.432-.156l.471.221c.163.076.233.27.156.433l-4.216 8.954a.325.325 0 01-.294.187H5.818l.373 2.677c.023.16.16.28.322.28"
            />
        </svg>
    );
};

export default React.memo(Cart);
